@if(loader.isLoading$ | async){
<div class="spinner-overlay">
  <mat-spinner></mat-spinner>
</div>
}